import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ChartTypes } from '@mode/shared/contract-common';
import { Subscription } from 'rxjs';
import { FormatListItem } from '../format-list-item';

const VALUES_DEFAULTS = {
  show: true,
} as const;

@Component({
  selector: 'mode-format-builder-values',
  templateUrl: './values.component.html',
  styleUrls: ['./values.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValuesComponent implements OnChanges, OnDestroy {
  @Input() field!: FormatListItem;
  @Input() valuesFormat!: ChartTypes.ValuesFormat;
  @Output() update = new EventEmitter<ChartTypes.ValuesFormat>();

  form = this.fb.group({
    show: [VALUES_DEFAULTS.show],
  });

  subscription: Subscription;

  constructor(private fb: UntypedFormBuilder) {
    this.subscription = this.form.valueChanges.subscribe((valuesFormat: ChartTypes.ValuesFormat) => {
      this.update.emit(valuesFormat);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.valuesFormat) {
      this.form.patchValue(
        {
          ...VALUES_DEFAULTS,
          ...this.valuesFormat,
        },
        {
          emitEvent: false,
        }
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
